import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import LandingPage from 'components/pages/LandingPage/LandingPage';
import ErrorPage from 'components/pages/ErrorPage/ErrorPage';
import Layout from 'components/layout/Layout';
import SuccessPage from 'components/pages/SuccessPage/SuccessPage';

const Routers = () => {
	return (
		<>
			<Router>
				<Layout>
					<Switch>
						<Route exact path='/overview' component={LandingPage} />
						<Route path='/404' component={ErrorPage} />
						<Route path='/success' component={SuccessPage} />
						<Route exact path='/' component={ErrorPage} />
					</Switch>
				</Layout>
			</Router>
		</>
	);
};

export default Routers;
